import { render, staticRenderFns } from "./SystemSnackbar.vue?vue&type=template&id=71ceef8e"
import script from "./SystemSnackbar.vue?vue&type=script&lang=js"
export * from "./SystemSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports